import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  "/login",
  "/auth-redirect",
  "/share",
  "/404",
  "/landingPage",
  "/shareSchedule"
]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
      NProgress.done();
    } else {
      if (to.path === "/404") {
        next();
        return;
      }
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles) {
        const routes = store.getters.permission_routes;
        const boolean = routes.some(item => {
          return item.url == "/dashboard";
        });
        if (!boolean) {
          routes.unshift({
            name: "工作台",
            url: "/dashboard",
            extra: "menu"
          });
        }
        // console.log(routes, "routes");
        const isNext = routeExists(routes, to);
        if (isNext) {
          next();
        } else {
          next("/404");
        }
      } else {
        try {
          const roles = await store.dispatch("user/getInfo");
          const accessRoutes = await store.dispatch(
            "permission/generateRoutes",
            roles
          );
          router.addRoutes(accessRoutes);
          next({ ...to, replace: true });
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch("user/resetToken");
          Message.error(error || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});

function routeExists(routes, to) {
  for (let item of routes) {
    if (
      item.url === to.path ||
      item.url === to.meta.parentPath ||
      to.path === "/share" ||
      to.path === "/shareSchedule" ||
      to.path === "/technician/message"
    ) {
      return true;
    }
    if (item.child && item.child.length > 0) {
      const existsInChildren = routeExists(item.child, to);
      if (existsInChildren) {
        return true;
      }
    }
  }
  return false;
}
